/*
 * - Definitions of file storage queries
 */

import { RequestStatus, StorageReasons } from '@src/utils/enums';
import FileStorageService from './service';
import {
  UploadPnAttachmentsRequest,
  UploadAirAttachmentsRequest,
  UploadFileResponse,
  DownloadFileRequest,
  SearchParams,
  DeleteFileRequest,
  DeleteParams,
  UploadRequestFilesRequest,
  UploadFilesResponse,
} from './types';

export class FileStorageMutations {
  public static readonly uploadRequestFiles = async ({
    projectId,
    requestId,
    version,
    fileData,
  }: UploadRequestFilesRequest): Promise<UploadFileResponse> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formData: any = new FormData();
    formData.append('overwrite', false);
    formData.append('isAnonymous', false);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fileData?.forEach((file: any) => {
      const fileMetaData = {
        ProjectID: projectId,
        RequestID: requestId,
        Version: version,
        Type: RequestStatus.Draft,
        Tags: file.tags,
      };
      formData.append('files', file?.file);
      formData.append('fileMetaData', JSON.stringify(fileMetaData));
    });

    const data = await FileStorageService.uploadRequestFiles(formData);
    return data;
  };
  public static readonly uploadPnAttachments = async ({
    publicNoticeId,
    daNumber,
    commentId,
    fileData,
  }: UploadPnAttachmentsRequest): Promise<UploadFilesResponse> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formData: any = new FormData();
    formData.append('publicNoticeId', publicNoticeId);
    formData.append('daNumber', daNumber);
    formData.append('commentId', commentId);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fileData?.forEach((file: any) => {
      formData.append('files', file);
    });

    const data = await FileStorageService.uploadPnAttachments(formData);
    return data;
  };
  public static readonly uploadAirAttachments = async ({
    projectID,
    requestID,
    version,
    ormAdditionalInfoActionID,
    fileData,
    status,
  }: UploadAirAttachmentsRequest): Promise<UploadFileResponse> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formData: any = new FormData();
    formData.append('overwrite', false);
    formData.append('isAnonymous', false);

    const tags = [
      { ormAdditionalInfoActionID: ormAdditionalInfoActionID },
      { section: 'Additional Information Request' },
    ];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fileData?.forEach((file: any) => {
      const fileMetaData = {
        ProjectID: projectID,
        RequestID: requestID,
        Version: version,
        Type: status,
        Tags: tags,
      };
      formData.append('files', file);
      formData.append('fileMetaData', JSON.stringify(fileMetaData));
    });

    const data = await FileStorageService.uploadAirAttachments(formData);
    return data;
  };

  public static readonly downloadFile = async ({
    fileName,
    projectID,
    requestID,
    version,
    reason,
    ormAdditionalInfoActionID,
    subFolder,
  }: DownloadFileRequest) => {
    const searchParams: SearchParams = { fileName, reason, ormAdditionalInfoActionID, subFolder };
    if (reason === StorageReasons.Project) {
      searchParams['projectID'] = projectID;
      searchParams['requestID'] = requestID;
      searchParams['version'] = version;
    }
    const data = await FileStorageService.downloadFile(searchParams);
    return data;
  };
  public static readonly deleteFile = async ({
    fileName,
    projectID,
    requestID,
    version,
    subFolder,
  }: DeleteFileRequest) => {
    const deleteParams: DeleteParams = { fileName, projectID, requestID, version, subFolder };
    const data = await FileStorageService.deleteFile(deleteParams);
    return data;
  };
}
